import { render, staticRenderFns } from "./InventoryVarianceReport.vue?vue&type=template&id=2b827656&scoped=true"
import script from "./InventoryVarianceReport.vue?vue&type=script&lang=js"
export * from "./InventoryVarianceReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryVarianceReport.vue?vue&type=style&index=0&id=2b827656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b827656",
  null
  
)

export default component.exports